import p from './training-record.vue';

export default p;
